export default {
	appParams: {
		thisActionDeleteParam: "Это действие удалит этот параметр: ",
		continue: "Продолжать",
		cancel: "Отмена"
	},
	bases: {
		selectActionWithBase: "Выберите действие с базой:",
		quanityOfTetheredApps: "Количество привязанных приложений:",
		selectAppsFromWhichUntieBase: "Выберите приложения, от которых отвязать базу:",
		untieBaseOfSelectedApps: "Отвязать базу из выбранных приложений",
		noAppsAttachedToBase: "К данной базе не привязано приложений",
		deleteBase: "Удалить базу",
		cancel: "Отменить",
		thisActionDeleteBaseWholly: "Это действие полностью удалит базу с отвязыванием ее от всех приложений. Продолжать?",
		cancellation: "Отмена",
		selectAppForUntie: "Выберите приложение для отвязывания",
		selectOperation: "Выберите операцию"
	},
	roles: {
		thisActionDeleteThisRole: "Это действие удалит эту роль:",
		continue: "Продолжать",
		cancellation: "Отмена",
	},
	sections: {
		selectAction: "Выберите действие с приложением:",
		numberOfLinkedBases: "Количество привязанных баз",
		selectBasesToUntie: "Выберите базы, которые отвязать от приложения",
		noUntiedBasesToThisApp: "К данному приложению не привязано баз",
		deleteApp: "Удалить приложение",
		cancel: "Отменить",
		thisActionDeleteAppWholly: "Это действие полностью удалит приложение с отвязкой всех баз и удалением всех связанных пакетов планировщика",
        	basesAndPackets: "Баз привязано: {bases}, участвует в {packets} пакете(-ах)",
	   	continue: "Продолжать",
		cancellation: "Отмена",
		selectAppForUntie: "Выберите приложение для отвязывания",
		selectOption: "Выберите операцию",
		selectAllBases: "Выбрать все базы",
		unselectAllBases: "Отменить все базы",
		untieSelectedBasesFromApp: "Отвязать выбранные базы от приложения"
	},
	servers: {
		versions: "Версии",
		hardwareInfo: "Ресурсы",
		mainAgentVersion: "Версия главного агента",
		tinyAgentsVersions: "Версии tiny-агентов",
		thisActionDeleteServer: "Это действие удалит этот сервер",
		continue: "Продолжать",
		attention: "Внимание",
		cancellation: "Отмена"
	},
	users: {
		errorYouCantDeleteDeveloper: "Ошибка. Нельзя удалить системного разработчика",
		actionDeleteThisUser: "Это действие удалит этого пользователя",
		continue: "Продолжать",
		cancellation: "Отмена"
	}
};